import React, { useEffect, useRef, useState } from "react";
import Lottie from 'react-lottie-player';
import { useHistory } from 'react-router-dom';
import Typed from "typed.js";
import {
  CAPTAIN_ROUTE,
  DEPENDENT_TREE_ROUTE,
  HOME_FEED,
  KID_LOGIN_ROUTE,
  MY_ROOM_ROUTE,
  NEXT_CHALLENGE_ROUTE,
  TREEHOUSE_ROUTE,
} from '../../../constants/routes.constants';
import { useAuth } from '../../auth/Auth';
import ForestMap from '../../../assets/images/fullMaptaletree.svg';
import TaleTreeMap from '../../../assets/images/TaleTreeMap.svg';
import galleryHome from '../../../assets/images/Creative_gallery.svg';
import galleryHouse from '../../../assets/images/Creative_gallery_house.svg';
import emraldMarketplace from '../../../assets/images/emerald-marketplace.svg';
import taletreeVillage from '../../../assets/images/taletree-village.svg';
import downtownEmeraldCity from '../../../assets/images/downtown-emerald-city.svg';
import commonRoom from '../../../assets/images/common-room.svg';
import theEmeraldReserves from '../../../assets/images/the-emerald-reserves.svg';
import Cloud1 from '../../../assets/images/cloud1.svg';
import Cloud2 from '../../../assets/images/cloud2.svg';
import Cloud3 from '../../../assets/images/cloud3.svg';
import roomsAvailable from '../../../assets/images/rooms-available.svg';
import mainGateLogin from '../../../assets/images/main-gate-login.svg';
import mainGateLoginArrow from '../../../assets/images/login-arrow.png';
import letsgoJson from '../../../assets/json/letsgo.json';
import codyJson from '../../../assets/json/cody.json';
import rootyJson from '../../../assets/json/rooty.json';
import rushmoreJson from '../../../assets/json/rushmore.json';
import uniJson from '../../../assets/json/Uni.json';
import domaJson from '../../../assets/json/doma.json';
import VolcanoJson from '../../../assets/json/Volcano_animation.json';
import loaderJson from '../../../assets/json/Loader.json';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import './Taletree.css';
import CloudTreeA from '../../../assets/images/cloud1.png';
import CloudTreeB from '../../../assets/images/cloud2.png';
import CloudTreeC from '../../../assets/images/cloud3.png';
import CloudTreeD from '../../../assets/images/cloud4.png';
import CloudTreeE from '../../../assets/images/cloud5.png';
import CloudTreeF from '../../../assets/images/cloud6.png';
import CloudTreeG from '../../../assets/images/cloud7.png';
import CloudTreeH from '../../../assets/images/cloud8.png';
import CloudTreeI from '../../../assets/images/cloud9.png';
import { nextChallengeViewModel } from '../next_challenge/next.challenge.viewmodel';
import ComingSoonModal from './ComingSoonModal';
import SpaceThemeImg from '../../../assets/images/sky-bg.png';

const TaletreeMap = () => {
  const history = useHistory();
  const { dependent, fetchAPI } = useAuth();
  const [zoomClass, setZoomClass] = useState('');
  // const [zoomInClass, setZoomInClass] = useState('');
  const [text, setText] = useState('');
  const [playDoma, setPlayDoma] = useState(false);
  const [playRooty, setPlayRooty] = useState(false);
  const [playLetsgo, setPlayLetsgo] = useState(false);
  const [playUni, setPlayUni] = useState(false);
  const [playRushmore, setPlayRushmore] = useState(false);
  const [playCody, setPlayCody] = useState(false);
  const [playVolcano, setPlayVolcano] = useState(false);
  const [playLoader, setPlayLoader] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [taletreeTreehousePointer, setTaletreeTreehousePointer] = useState('');
  const [dependentBranches, setDependentBranches] = useState([]);
  const [tagList, setTaglist] = useState([]);
  const [cloudAnimationDisplay, setCloudAnimationDisplay] = useState('none');
  const [showComingSoonPopup, setShowComingSoonPopup] = useState(false);
  const [comingSoonType, setComingSoonType] = useState('Marketplace');
  const typedRef = useRef();

  const ZoomOutFunction = (location) => {
    setZoomClass('zoom-out');
    setTimeout(() => {
      const path =
        location === 'emerald city'
          ? NEXT_CHALLENGE_ROUTE
          : dependent
          ? MY_ROOM_ROUTE
          : KID_LOGIN_ROUTE;
      history.push({
        pathname: path,
        state: { from: 'map' },
      });
    }, 100);
  };

  useEffect(() => {
    setTimeout(() => {
      setPlayVolcano(true);
    }, 2000);
    if (window.location.hostname === 'taletree.com') {
      setTaletreeTreehousePointer('add-pointer');
    } else {
      setTaletreeTreehousePointer('remove-pointer');
    }
  }, []);

  useEffect(() => {
    if (text) {
      const typed = new Typed(typedRef.current, {
        strings: [text],
        typeSpeed: 20,
      });

      return () => {
        // Destroy Typed instance during cleanup to stop animation
        typed.destroy();
      };
    }
  }, [text]);

  const handleMainGateClick = () => {
    if (!dependent) {
      history.push(KID_LOGIN_ROUTE);
    } else {
      history.push(NEXT_CHALLENGE_ROUTE);
    }
  };

  const handleKidRoomClick = () => {
    if (dependent) {
      history.push(MY_ROOM_ROUTE);
    }
  };

  const onTaletreeTreehouseClick = () => {
    if (window.location.hostname === 'taletree.com') {
      history.push(`${TREEHOUSE_ROUTE}/taletree`);
    }
  };

  const onCaptainClick = () => {
    if (dependent && dependent?.profile?.group?.id) {
      history.push(`${CAPTAIN_ROUTE}/${dependent?.profile?.group?.id}`);
    }
  };

  const setImageLoadedFun = () => {
    setTimeout(() => {
      setShowLoader(false);
      setPlayLoader(false);
    }, 2000);
  };

  const getBranchList = () => {
    fetchAPI(nextChallengeViewModel.getBranch)
      .then((res) => {
        setDependentBranches(res);
      })
      .catch((err) => {});
  };

  const getTagList = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 5 })
      .then((res) => {
        setTaglist(res);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (dependent) {
      getBranchList();
    } else {
      getTagList();
    }
  }, [dependent]);

  const getBranchesClass = (key) => {
    switch (key) {
      case 0:
        return '';
      case 1:
        return 'world-plan';
      case 2:
        return 'blue-plan';
      case 3:
        return 'green-plan';
      case 4:
        return 'light-pink-plan';
      default:
        break;
    }
  };

  const handleTreeClick = () => {
    setCloudAnimationDisplay('flex');
    setTimeout(() => {
      if (dependent?.username) {
        history.push(`${DEPENDENT_TREE_ROUTE}/${dependent?.username}`);
      } else {
        history.push(DEPENDENT_TREE_ROUTE);
      }
    }, [1000]);
  };

  const handleEmeraldMarketplaceClick = () => {
    setComingSoonType('Marketplace');
    setShowComingSoonPopup(true);
  };

  const handleEmeraldReservesClick = () => {
    setComingSoonType('Reserves');
    setShowComingSoonPopup(true);
  };

  const handleCreativeGalleryClick = () => {
    history.push(HOME_FEED);
  };

  return (
    <>
      <div
        className="map-loader"
        style={{
          display: showLoader ? '' : 'none',
          backgroundImage: `url(${SpaceThemeImg})`,
          backgroundColor: 'unset',
          zIndex: 1,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <Lottie
          loop={true}
          play={playLoader}
          animationData={loaderJson}
          className="map-loader-in"
        />
      </div>
      <div style={{ display: !showLoader ? 'block' : 'none' }}>
        {dependent ? <CampHeader /> : <CampHeaderGuest />}
        {showComingSoonPopup && (
          <ComingSoonModal
            showModal={showComingSoonPopup}
            setShowModal={setShowComingSoonPopup}
            type={comingSoonType}
          />
        )}
        <div className={`map-wrapper ${zoomClass}`}>
          <div className="map-bg">
            <img src={ForestMap} alt="Forest Map" onLoad={setImageLoadedFun} />
            <div className="clouds-wrapper">
              <div className="cloud cloud-1 map-object">
                <img src={Cloud1} alt="Cloud" />
              </div>
              <div className="cloud cloud-2 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-3 map-object">
                <img src={Cloud3} alt="Cloud" />
              </div>
              <div className="cloud cloud-4 map-object">
                <img src={Cloud3} alt="Cloud" />
              </div>
              <div className="cloud cloud-5 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-6 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-7 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-8 map-object">
                <img src={Cloud1} alt="Cloud" />
              </div>
              <div className="cloud cloud-9 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-10 map-object">
                <img src={Cloud1} alt="Cloud" />
              </div>
              <div className="cloud cloud-11 map-object">
                <img src={Cloud1} alt="Cloud" />
              </div>
              <div className="cloud cloud-12 map-object">
                <img src={Cloud3} alt="Cloud" />
              </div>
              <div className="cloud cloud-13 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-14 map-object">
                <img src={Cloud2} alt="Cloud" />
              </div>
              <div className="cloud cloud-15 map-object">
                <img src={Cloud1} alt="Cloud" />
              </div>
              <div className="cloud cloud-16 map-object">
                <img src={Cloud1} alt="Cloud" />
              </div>
            </div>

            <div
              class="clouds-container"
              style={{ display: cloudAnimationDisplay }}
            >
              <div class="cloudS cloud1">
                <img src={CloudTreeA} alt="Cloud" />
              </div>
              <div class="cloudS cloud2">
                <img src={CloudTreeB} alt="Cloud" />
              </div>
              <div class="cloudS cloud3">
                <img src={CloudTreeC} alt="Cloud" />
              </div>
              <div class="cloudS cloud4">
                <img src={CloudTreeD} alt="Cloud" />
              </div>
              <div class="cloudS cloud5">
                <img src={CloudTreeE} alt="Cloud" />
              </div>
              <div class="cloudS cloud6">
                <img src={CloudTreeF} alt="Cloud" />
              </div>
              <div class="cloudS cloud7">
                <img src={CloudTreeG} alt="Cloud" />
              </div>
              <div class="cloudS cloud8">
                <img src={CloudTreeH} alt="Cloud" />
              </div>
              <div class="cloudS cloud9">
                <img src={CloudTreeI} alt="Cloud" />
              </div>
            </div>

            <div className="volcano map-object">
              <Lottie
                loop={true}
                play={playVolcano}
                animationData={VolcanoJson}
              />
            </div>
            <div
              className="emrald-marketplace coming-soon-tooltip map-object"
              onClick={handleEmeraldMarketplaceClick}
            >
              {/* <img className="login-arrow" src={MapHoverImg} alt="Log in" /> */}

              <img src={emraldMarketplace} alt="emrald-marketplace" />
              <div className="map-tooltip">
                <div className="map-tooltip-inner">
                  <p>Coming soon</p>
                </div>
              </div>
            </div>
            <div
              className="taletree-village map-object"
              onClick={() => ZoomOutFunction('village')}
            >
              <img src={taletreeVillage} alt="Taletree Village" />
            </div>

            <div
              className="downtown-emerald-city map-object"
              onClick={() => ZoomOutFunction('emerald city')}
              style={{
                zIndex: 9,
              }}
            >
              <img src={downtownEmeraldCity} alt="Downtown Emerald City" />
            </div>
            <div
              className="taletree-house map-object house-gallery"
              onClick={handleCreativeGalleryClick}
            >
              <img src={galleryHome} alt="taletree-house" />

              {/* <img className="login-arrow" src={MapHoverImg} alt="Log in" /> */}
            </div>

            {/* <div className="map-object main-tree" onClick={handleTreeClick}> */}
            <div
              className="map-object main-tree"
              onClick={handleTreeClick}
              added
            >
              <img src={TaleTreeMap} alt="tree" />

              {dependent
                ? dependentBranches.slice(0, 5).map((item, key) => {
                    return (
                      <div
                        key={key}
                        className={`branches-interest ${getBranchesClass(key)}`}
                      >
                        <div className="interest-brnaches">#{item?.tag}</div>
                      </div>
                    );
                  })
                : tagList.map((item, key) => {
                    return (
                      <div
                        key={key}
                        className={`branches-interest ${getBranchesClass(key)}`}
                      >
                        <div className="interest-brnaches">#{item?.tag}</div>
                      </div>
                    );
                  })}
              {/* <img className="login-arrow" src={MapHoverImg} alt="Log in" /> */}
            </div>
            <div className="map-object gallery-house-img">
              <img src={galleryHouse} alt="taletree-house" />
            </div>
            <div
              className="common-room map-object"
              style={{ cursor: 'pointer' }}
              onClick={onCaptainClick}
            >
              {/* <img className="login-arrow" src={MapHoverImg} alt="Log in" /> */}
              <img src={commonRoom} alt="Common Room" />
              {dependent?.profile?.group?.id && (
                <div className="map-tooltip tooltip-center-pointer">
                  <div className="map-tooltip-inner">
                    <p>{`Camp: ${dependent?.school_details?.school_name}.`}</p>
                    <p>{`Tribe: ${dependent?.profile?.group?.name}.`}</p>
                  </div>
                </div>
              )}
            </div>
            <div
              className="rooms-available map-object"
              onClick={handleKidRoomClick}
            >
              {/* <img className="login-arrow" src={MapHoverImg} alt="Log in" /> */}
              <img src={roomsAvailable} alt="rooms-available" />
              <div className="map-tooltip tooltip-center-pointer">
                <div className="map-tooltip-inner">
                  {dependent ? (
                    <p>{dependent?.username}'s room</p>
                  ) : (
                    <p>This room is available for you!</p>
                  )}
                </div>
              </div>
            </div>
            <div
              className="enroll-plan map-object spiral-enroll-plan"
              onClick={onCaptainClick}
            >
              {/* <img src={campCaptain} alt="enroll plan" /> */}
              <div className="map-tooltip tooltip-center-pointer">
                <div className="map-tooltip-inner">
                  {dependent && dependent?.profile?.group?.id ? (
                    <p>
                      Captain{' '}
                      {`${dependent?.profile?.group?.captain_details?.first_name} ${dependent?.profile?.group?.captain_details?.last_name}`}
                    </p>
                  ) : (
                    <p>Enrol to the villagers plan today!</p>
                  )}
                </div>
              </div>
            </div>
            <div
              className="the-emerald-reserves coming-soon-tooltip map-object"
              onClick={handleEmeraldReservesClick}
            >
              {/* <img className="login-arrow" src={MapHoverImg} alt="Log in" /> */}

              <img src={theEmeraldReserves} alt="The Emerald Reserves" />
              <div className="map-tooltip">
                <div className="map-tooltip-inner">
                  <p>Coming soon</p>
                </div>
              </div>
            </div>

            <div
              className="main-gate-login map-object"
              onClick={handleMainGateClick}
            >
              <img src={mainGateLogin} alt="Main gate for login" />
              {!dependent && (
                <>
                  <img
                    className="login-arrow"
                    src={mainGateLoginArrow}
                    alt="Log in"
                  />
                  <div className="map-tooltip tooltip-center-pointer">
                    <div className="map-tooltip-inner">
                      <p>Log in</p>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div
              className="lottie-character lottie-doma"
              onMouseOut={() => setPlayDoma(false)}
              onMouseOver={() => setPlayDoma(true)}
            >
              <Lottie
                loop={true}
                play={playDoma}
                animationData={domaJson}
                className="lottie-character-wrapper"
              />
              <div className="map-tooltip">
                <div className="lottie-name">
                  My name is <span>Doma</span>
                </div>
                <div className="map-tooltip-inner">
                  {/* <h4>I am healthy!</h4> */}
                  <p>
                    I'm Doma and I'm healthy!
                    <br />
                    Gain fresh new ideas by staying active, eating healthy, and
                    sleeping lots.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="lottie-character lottie-rooty"
              onMouseOut={() => setPlayRooty(false)}
              onMouseOver={() => setPlayRooty(true)}
            >
              <Lottie
                loop={true}
                play={playRooty}
                animationData={rootyJson}
                className="lottie-character-wrapper"
              />
              <div className="map-tooltip">
                <div className="lottie-name">
                  My name is <span>Rooty</span>
                </div>
                <div className="map-tooltip-inner">
                  {/* <h4>I keep myself and my friends safe!</h4> */}
                  <p>
                    I'm Rooty and I keep myself and my friends safe!
                    <br />
                    Build good habits and be confident you can do things on your
                    own.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="lottie-character lottie-rushmore"
              onMouseOut={() => setPlayRushmore(false)}
              onMouseOver={() => setPlayRushmore(true)}
            >
              <Lottie
                loop={true}
                play={playRushmore}
                animationData={rushmoreJson}
                className="lottie-character-wrapper"
              />
              <div className="map-tooltip">
                <div className="lottie-name">
                  My name is <span>Rushmore</span>
                </div>
                <div className="map-tooltip-inner">
                  {/* <h4>I am happy to be myself!</h4> */}
                  <p>
                    I'm Rushmore and I'm happy to be myself!
                    <br />
                    Celebrate your authenticity and individuality.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="lottie-character lottie-uni"
              onMouseOut={() => setPlayUni(false)}
              onMouseOver={() => setPlayUni(true)}
            >
              <Lottie
                loop={true}
                play={playUni}
                animationData={uniJson}
                className="lottie-character-wrapper"
              />
              <div className="map-tooltip">
                <div className="lottie-name">
                  My name is <span>Uni</span>
                </div>
                <div className="map-tooltip-inner">
                  {/* <h4>I am kind!</h4> */}
                  <p>
                    I'm Uni and I'm kind!
                    <br />
                    Bring joy and happiness to yourself and to the world.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="lottie-character lottie-letsgo"
              onMouseOut={() => setPlayLetsgo(false)}
              onMouseOver={() => setPlayLetsgo(true)}
            >
              <Lottie
                loop={true}
                play={playLetsgo}
                animationData={letsgoJson}
                className="lottie-character-wrapper"
              />
              <div className="map-tooltip">
                <div className="lottie-name">
                  My name is <span>Letsgo</span>
                </div>
                <div className="map-tooltip-inner">
                  {/* <h4>I am curious!</h4> */}
                  <p>
                    I'm Letsgo and I'm curious!
                    <br />
                    Explore the world of your imagination and creativity.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="lottie-character lottie-cody"
              onMouseOut={() => setPlayCody(false)}
              onMouseOver={() => setPlayCody(true)}
            >
              <Lottie
                loop={true}
                play={playCody}
                animationData={codyJson}
                className="lottie-character-wrapper"
              />
              <div className="map-tooltip">
                <div className="lottie-name">
                  My name is <span>Cody</span>
                </div>
                <div className="map-tooltip-inner">
                  {/* <h4>I am motivated!</h4> */}
                  <p>
                    I'm Cody and I'm motivated!
                    <br />
                    Build good habits and be confident you can do things on your
                    own.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaletreeMap